import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import { Icon } from 'components/Icon';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { ThemedComponent } from 'ui/theme';
import { MaterialCheckbox, StyledFormControlLabel } from './styled';

export const Check = (props) => {
  const {
    id,
    checked,
    onChange,
    label,
    title,
    secondary,
    align = 'left',
    color = 'purple',
    nowrap = false,
  } = props;

  const [active, setActive] = useState(checked);
  const action = () => {
    const nv = !active;
    if (onChange && typeof onChange === 'function') {
      onChange(nv, props);
    }
    setActive(nv);
  };

  useEffect(() => {
    setActive(checked);
  }, [checked]);

  return (
    <>
      <ThemedComponent>
        <FormGroup>
          {title ? (
            <FormLabel
              component="legend"
              color={secondary ? 'secondary' : 'primary'}
            >
              {title}
            </FormLabel>
          ) : null}
          <StyledFormControlLabel
            nowrap={nowrap}
            control={
              <MaterialCheckbox
                id={id}
                checked={checked}
                onChange={action}
                color={color}
                checkedIcon={
                  <Icon
                    name={'check'}
                    elementAttributes={{ className: 'checked-box-icon' }}
                    size={14}
                  />
                }
                icon={
                  <Icon
                    name={'check'}
                    elementAttributes={{ className: 'box-icon' }}
                    size={14}
                  />
                }
                align={align}
              />
            }
            label={label}
            style={{
              display: 'flex',
              justifyContent: align === 'center' ? 'center' : 'flex-start',
              width: '100%',
              height: '30px',
            }}
          />
        </FormGroup>
      </ThemedComponent>
    </>
  );
};

Check.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  checked: PropTypes.bool,
  secondary: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  align: PropTypes.oneOf(['left', 'center']),
};

Check.defaultProps = {
  label: '',
  title: '',
  checked: false,
  secondary: false,
  onChange: undefined,
  align: 'left',
};

export default Check;
